import { useMemo } from 'react';

import {
  DEFAULT_SUGGESTION_MODE_LABEL,
  getGenerationModeDescription,
  getGenerationModeLabel,
} from 'src/data/generation';
import { doesToolSupportMixtureModes } from 'src/data/generationTool';
import { useBrandVoicesAssets } from 'src/store';

const getItemLabel = ({ customFormulas, generationTool, selectedModeId }) => {
  const customFormula = customFormulas?.find(
    (t) => t.generationTool === generationTool && t.id === selectedModeId
  );
  if (customFormula) {
    return customFormula.name;
  }

  return getGenerationModeLabel(selectedModeId, generationTool);
};

export const useItems = ({
  generationTool,
  selectedModeId,
  subGenerationToolsProps,
  maxChars,
  errors,
}) => {
  const { customFormulas } = useBrandVoicesAssets();
  const subGenerationToolsPropsString = JSON.stringify(subGenerationToolsProps) || '';

  return useMemo(() => {
    const createItem = (tool, modeId, maxChars, errors) => {
      const title = getItemLabel({ customFormulas, generationTool: tool, selectedModeId: modeId });
      const subtitle =
        title !== DEFAULT_SUGGESTION_MODE_LABEL ? getGenerationModeDescription(modeId, tool) : '';

      return { tool, title, subtitle, maxChars, errors };
    };

    // In case of a "mixture" tool, create an item for each sub-generation tool
    if (doesToolSupportMixtureModes(generationTool)) {
      return Object.keys(subGenerationToolsProps).map((subTool) =>
        createItem(
          subTool,
          subGenerationToolsProps[subTool]?.selectedModeId,
          subGenerationToolsProps[subTool]?.maxChars,
          subGenerationToolsProps[subTool]?.errors
        )
      );
    }

    // Or a single item for a "regular" tool
    return [createItem(generationTool, selectedModeId, maxChars, errors)];
    // subGenerationTools inner values change and we want to make sure that we check if there was a change in any of them to recompute the items
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    customFormulas,
    errors,
    generationTool,
    maxChars,
    selectedModeId,
    subGenerationToolsPropsString,
  ]);
};
